import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IUiState } from '@shared/types/ui/ui.type';

export const selectUiFeature = createFeatureSelector<Readonly<IUiState>>('ui');

export const selectSelectedMenuItem = createSelector(selectUiFeature, (state) => state.selectedMenuItem);

export const selectLoader = createSelector(selectUiFeature, (state) => state.loader);

export const selectSidebarLoader = createSelector(selectUiFeature, (state) => state.contentLoader);

export const selectMenuItems = createSelector(selectUiFeature, (state) => state.menuItems);
